/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CopyProductDto { 
    productId: string;
    placement: string;
    translationIds?: Array<string>;
    productType?: CopyProductDto.ProductTypeEnum;
    sku?: string;
}
export namespace CopyProductDto {
    export const ProductTypeEnum = {
        simple: 'simple',
        variable: 'variable',
        upsell: 'upsell',
        bundle: 'bundle'
    } as const;
    export type ProductTypeEnum = typeof ProductTypeEnum[keyof typeof ProductTypeEnum];
}


